import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Radio, Table, Typography, Avatar, Icon } from "antd";

import * as employeesActions from "../../../../Employees/redux/actions/profiles";
import Spinner from "../../../../../common/components/spinner/Spinner";
import { API } from "../../../../../common/api/constants";
import TablePageSize from "../../../../../common/components/TablePageSize";
import "./SelectDriver.css";

const { getDrivers } = employeesActions;

const { Text } = Typography;

let tablePlaceholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;

const DriversTable = props => {
  useEffect(() => {
    dispatch(getDrivers());
  }, []);
  const [pages, setPages] = useState(3);
  const dispatch = useDispatch();
  const employees = useSelector(state => state.Employees.profiles);
  const driversList = employees && employees.drivers;
  function renderColumns() {
    return [
      {
        title: "",
        dataIndex: "driver",
        key: "photo",
        render: (_, driver) => (
          <>
            {driver.photo ? (
              <img
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}
                src={`${API.replace("/api", "")}${driver.photo}`}
                alt=""
              />
            ) : (
              <Avatar shape="square" size="large" icon="user" />
            )}
          </>
        )
      },
      {
        title: "ФИО",
        dataIndex: "driver",
        key: "fio",
        width: "50%",
        render: (_, driver) => (
          <span>
            {driver.lastname && driver.lastname} <br />{" "}
            <Text type="secondary">
              {driver.name && driver.name}{" "}
              {driver.patronymic && driver.patronymic}
            </Text>
          </span>
        ),
        sorter: (a, b) => {
          return a.driver.lastname.localeCompare(b.driver.lastname);
        }
      },
      {
        title: "Дата и время окончания последнего заказа",
        dataIndex: "driver",
        key: "orderInfo",
        width: "50%"
      }
    ];
  }
  function changePaginationSize(e) {
    setPages(Number(e));
  }

  function onRow(row) {
    return {
      onClick: () => {
        props.selectDriver(row);
      }
    };
  }

  if (employees.isLoading) {
    return <Spinner />;
  }

  return (
    <div className="basicForm">
      <div className="drivers">
        <div className="drivers__header">
          <div className="drivers__types">
            <Radio.Group defaultValue="active" size="large">
              <Radio.Button>
                Водители: {driversList && driversList.length}
              </Radio.Button>
            </Radio.Group>
          </div>
        </div>
        <div className="drivers__wrap">
          {/* todo next release 
          <div className="drivers__filter">
            <Search
              placeholder="Поиск по сотрудникам"
              style={{ width: 224 }}
              className="drivers-search"
            />
          </div>
          */}
          <div className="employees__table">
            <Table
              dataSource={driversList}
              pagination={{
                pageSize: pages
              }}
              locale={{
                emptyText: employees.isLoading
                  ? tablePlaceholder
                  : "Водителей нет"
              }}
              onRow={onRow}
              rowKey="id"
              columns={renderColumns()}
            />
            {driversList && driversList.length > 0 ? (
              <TablePageSize
                pages={pages}
                changePaginationSize={changePaginationSize}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriversTable;
